<template>
<div>
<label for="filter">
    <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>
    <strong>Filtra</strong></label>
    <input @input="$emit('update',$event.target.value)" class="form-control" type="text" name="query" v-model="filterKey">
</div>
</template>
<script>

export default {
  props  : [''],
  data () 
  {
    return {
      filterKey : ''
    }
    
    },
 
   created () 
    {
         
    },
  methods: {
    
  }
}
</script>

<style 

</style>
